import React from "react";
import styles from "./PGProgramme.module.css";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import CustomiseCta from "../CustomiseCta/CustomiseCta";
import { ChevronRight } from "lucide-react";

interface CardWithImage {
  id: number;
  title_description: {
    id: number;
    title: string;
    description: string;
  };
  images: {
    id: number;
    documentId: string;
    url: string;
  }[];
}
interface ProgramListItem {
  id: number;
  label: string;
  url: string;
}
interface DataWithImageAndPrograms {
  id: number;
  card_with_image: CardWithImage;
  programs_list: ProgramListItem[];
  cta?: any;
}
interface Props {
  data: DataWithImageAndPrograms;
}
const PGProgramme: React.FC<Props> = ({ data }) => {
  const router = useRouter();
  const urlSchool = router?.query?.slug;

  const { card_with_image, programs_list, cta } = data;
  return (
    <div className={styles.pgProgrammeContainer}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6">
            <Image
              src={card_with_image?.images[0].url}
              alt="desktop-image"
              title="desktop-image"
              width={620}
              height={400}
              sizes="(max-width: 768px) 100vw, 620px"
              className={`${styles.responsiveImage} img-fluid`}
              style={{
                width: "100%",
                height: "auto",
                maxWidth: "620px",
              }}
            />
          </div>

          <div className="col-md-6">
            <h2 className={styles.pgProgrammeHeader}>
              {card_with_image?.title_description?.title}{" "}
            </h2>
            {(
              (typeof urlSchool === "string" && urlSchool !== "business-school") ||
              (Array.isArray(urlSchool) && urlSchool[1] !== "business-school")
            ) && (
              <p className={styles.pgProgrammeDesc}>
                {card_with_image?.title_description?.description}
              </p>
            )}
            <div>
              {programs_list?.map((program) => (
                <p key={program?.id} className={styles.pgProgrammePro}>
                  <Link
                    href={program?.url}
                    className={styles.pgProgrammeProLinks}
                    title={program?.label}
                  >
                    {program?.label} <ChevronRight />
                  </Link>
                </p>
              ))}
            </div>
            <div className={styles.btnContainer}>
              <CustomiseCta ctaData={cta} btnLabelDesktop="Enquire Now" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PGProgramme;
